(function() {
  angular.module("app").directive("clickOutToClose", [
    "$document",
    "$timeout",
    function($document, $timeout) {
      return {
        restrict: "A",
        link: function(scope, elem, attr, ctrl) {
          var elemClickHandler = function(e) {
            e.stopPropagation();
          };

          var docClickHandler = function(e) {
            $timeout(function() {
              scope.$apply(attr.clickOutToClose);
            });
          };

          elem.on("click", elemClickHandler);
          $document.on("click", docClickHandler);

          // teardown the event handlers when the scope is destroyed.
          scope.$on("$destroy", function() {
            elem.off("click", elemClickHandler);
            $document.off("click", docClickHandler);
          });
        }
      };
    }
  ]);
})();
